import { graphql } from "@opensea/graphql"

export const TokenPriceFragment = graphql(`
  fragment TokenPrice on Price {
    usd
    token {
      unit
      symbol
      contractAddress
      chain {
        identifier
      }
    }
  }
`)
